import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api, imageUrl } from "@/lib/api";
import { CATEGORIES, PRODUCTS as DEMO } from "@/data/shop";

const PLACEHOLDER = "data:image/svg+xml;utf8," + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4 3"><rect width="4" height="3" fill="#FFF3C4"/></svg>');

export const fromApi = (p) => {
  const images = p.images.length ? p.images.map(imageUrl) : [PLACEHOLDER];
  return {
    id: p.id,
    name: p.title,
    category: CATEGORIES.find((c) => c.id === p.category)?.name,
    categoryId: p.category,
    clearance: p.category === "clearance",
    price: p.price,
    was: p.reference_price > p.price ? p.reference_price : undefined,
    condition: p.condition,
    conditionNotes: p.condition_notes,
    brand: p.brand,
    desc: p.description,
    included: p.included,
    defects: p.defects,
    sku: p.sku,
    deliveryCharge: p.delivery_charge,
    qty: p.quantity,
    img: images[0],
    images,
    oneOff: p.quantity === 1,
    popular: !!p.popular,
    seller: { id: "shopabee", name: "ShopaBee" },
  };
};

const ProductsContext = createContext({ products: DEMO, loading: true, refresh: () => {} });
export const useProducts = () => useContext(ProductsContext);

export const ProductsProvider = ({ children }) => {
  const [real, setReal] = useState([]);
  const [loading, setLoading] = useState(true);
  const refresh = useCallback(() => api.get("/products")
    .then((r) => setReal(r.data.map(fromApi)))
    .catch(() => setReal([]))
    .finally(() => setLoading(false)), []);
  useEffect(() => {
    refresh();
  }, [refresh]);
  const products = useMemo(() => [...real, ...DEMO], [real]);
  return <ProductsContext.Provider value={{ products, loading, refresh }}>{children}</ProductsContext.Provider>;
};
